<template>
  <div class="page_content asset pg-upload" aria-label="Upload Asset Page Content">
    <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
      <div class="hidden-container">
        <input type="file" id="csvFileId" ref="csvFileInput" name="csvFile" @change="fileToBeUploaded" />
        <input type="file" id="fileListId" ref="fileInput" name="fileList" rel="multipleFile" multiple="multiple" @change="fileToBeUploaded" />
      </div>
      <div class="row page-heading border-0">
        <div class="col-8 input module_heading">
          <span class="icon-cloud2 float-left"></span>
          <span class="head_txt ace_sec_txt">Asset Upload</span>
        </div>
        <div class="col-4 btn_container">
          <div class="btns_group">
            <button type="button" class="btn btn-cancel" @click.prevent="cancel" aria-label="cancel"><span class="icon-cross"></span></button>
            <template v-if="isBulkUpload">
              <button type="button" class="btn btn-primary" :disabled="!enableUploadCSVContent" @click.prevent="uploadLearningContent" aria-label="upload">upload</button>
            </template>
            <template v-else>
              <button type="button" class="btn btn-primary" :disabled="(fileUploadArray.length === 0)" @click.prevent="uploadLearningContent" aria-label="upload">upload</button>
            </template>
            <template v-if="fileUploadArray.length > 0">
              <button type="button" class="btn btn-primary" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</button>
            </template>
          </div>
        </div>
      </div>
      <div class="">
        <b-col cols="12" class="asset-fields-section">
          <span class="icon-help" aria-label="help" @click="viewHelpSection($event)"></span>
          <b-row>
            <b-col cols="6" class="asset-folder">
              <div class="label">
                <label for="folder" id="assetUpload">Asset Folder<sup>*</sup></label>
              </div>
              <div>
                <select id="folder" v-model="owningLibrary" aria-labelledby="assetUpload">
                  <option v-for="folder in folders" :value="{uuid: folder.uuid, displayName: folder.displayName}">{{ folder.displayName }}</option>
                </select>
              </div>
            </b-col>
            <b-col cols="6" class="asset-tags">
              <div>
                <div class="label">
                  <span class="ic-tag general mr-2"></span>
                  <label>Tags</label>
                  <button class="btn_ic icon-edit" type="button" title="add tag" aria-label="add tag" @click="showAddTagPopup($event)"></button>
                </div>
                <div class="value">
                  <div class="tag-box-list">
                    <template v-for="(values, key, i) in appliedTagMap" class="tags_container">
                      <span class="tag" v-for="(tag, j) in values">
                      <span class="tag_name instructional_tag ace_sec_txt">{{tag.name}}</span>
                      </span>
                    </template>
                  </div>
                </div>
                <template>
                  <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
                </template>
              </div>
            </b-col>
            <!--
              <b-col cols="3" class="asset-license">
                  <div>
                      <div class="label">
                          <label>License</label>
                      </div>
                      <div class="value">
                          <div class="input_container">
                              <input
                                  type="text"
                                  class="pl-2">
                          </div>
                      </div>
                  </div>
              </b-col>
              -->
          </b-row>
        </b-col>
      </div>
      <div class="mt-5 upload-asset-section">
        <template v-if="fileUploadArray.length > 0">
          <b-col cols="12">
            <table class="table table-bordered border text-center">
              <thead>
                <tr>
                  <th class="first-column">
                    <label class="form-checkbox">
                    <input type="checkbox" v-model="selectAll" @click="select">
                    <i class="form-icon"></i>
                    </label>
                  </th>
                  <th class="second-column">Asset Name</th>
                  <th class="third-column">File Name</th>
                  <th class="fourth-column">Asset Folder</th>
                  <th class="last-column">Asset Tags</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in fileUploadArray">
                  <td class="first-column">
                    <label class="form-checkbox">
                    <input type="checkbox" :value="item.id" v-model="selected">
                    <i class="form-icon"></i>
                    </label>
                  </td>
                  <td class="second-column"><span class="label-section">{{item.title}}</span></td>
                  <td class="third-column"><span class="label-section">{{item.fileName}}</span></td>
                  <td class="fourth-column"><span class="label-section">{{owningLibrary.displayName}}</span></td>
                  <td class="last-column">
                    <div class="tag-box-Tablelist">
                      <div class="grid-tag-list-length">
                        <template v-for="(values, key, i) in item.appliedTagMap">
                          <span class="tag" v-for="(tag, j) in values">
                          <span class="tag_name"> {{ tag.name }} </span>
                          </span>
                        </template>
                        <template v-for="(values, key, i) in appliedTagMap">
                          <span class="tag" v-for="(tag, j) in values">
                          <span class="tag_name"> {{ tag.name }} </span>
                          </span>
                        </template>
                        <span class="tag" v-for="tag in assetTags">
                        <span class="tag_name"> {{ tag.name }} </span>
                        </span>
                      </div>
                      <div class="tag-box ellipsisTagsInTable" @click="showTableTags">
                        <span class="tag-box-content"> ... </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-modal id="tableAssetTagsPopup" size="lg" :title="'Asset Tags'" centered hide-footer>
            <div class="saveChanges">
              <div class="tag-box-list" style="height: 73px; padding-top: 8px;">
                <template v-for="(values, key, i) in appliedTagMap">
                  <span class="tag" v-for="(tag, j) in values">
                  <span class="tag_name"> {{ tag.name }} </span>
                  </span>
                </template>
              </div>
            </div>
            <div slot="modal-header" class="header-section">
              <div class="popup-heading">Asset Tags</div>
              <button type="button" class="btn_close" @click="closeTableTags" aria-label="close">
                <span class="ic-close"></span>
              </button>
            </div>
          </b-modal>
        </template>
        <template v-else>
          <b-col cols="12">
            <b-row>
              <b-col cols="6" class="upload-asset-thru-pc">
                <div class="card">
                  <span class="icon-help" aria-label="help" @click="viewHelpSection($event)"></span>
                  <div class="heading">Upload Assets from Your Computer</div>
                  <div class="thumbnail-section">
                    <span class="icon-laptop"></span>
                  </div>
                  <div class="card-body text-center">
                    <button type="button" class="btn btn-primary" @click.stop="chooseFile(false)" aria-label="choose assets from local computer">choose assets from local computer</button>
                  </div>
                </div>
              </b-col>
              <!--
              <b-col cols="4" class="upload-asset-thru-cd">
                <div class="card">
                  <span class="icon-help" aria-label="help" @click="viewHelpSection($event)"></span>
                  <div class="heading">Upload Assets from <br> Cloud Drives</div>
                  <div class="thumbnail-section">
                    <span class="icon-cloudDrive"></span>
                  </div>
                  <div class="card-body text-center">
                    <button type="button" class="btn btn-primary" @click.stop="chooseFile(true)">choose assets from  cloud drives</button>
                  </div>
                </div>
              </b-col>
              -->
              <b-col cols="6" class="upload-asset-thru-csv">
                <div class="card">
                  <span class="icon-help" aria-label="help" @click="viewHelpSection($event)"></span>
                  <div class="heading">Upload Assets thru a CSV File</div>
                  <div class="thumbnail-section">
                    <span class="icon-csvFile"></span>
                  </div>
                  <div class="card-body text-center">
                    <button type="button" class="btn btn-primary" @click.stop="chooseFile(true)" aria-label="choose CSV file">choose CSV file</button>
                  </div>
                  <div class="sample-csv">
                    <a href="https://pragya2.s3-us-west-2.amazonaws.com/asset.csv" target="_blank" aria-label="click here to get a copy of the sample csv file.">Click here</a> to get a copy of the sample csv file.
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </template>
      </div>
      <div>
        <b-modal ref="deleteConfirmModal" :title="'Please Confirm!'" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div style="text-align: center;">
            <h6>Are you sure to delete ({{ selected.length }}) Assets?</h6>
          </div>
          <div slot="modal-footer" class="w-100">
            <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> ok </b-button>
            <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> cancel </b-button>
          </div>
        </b-modal>
      </div>
      <div class="asset-upload-popup">
        <b-modal ref="uploadSuccessModal" size="lg" :title="uploadSuccessTitle" :header-bg-variant="'discover-content-delete-modal'" hide-header-close hide-footer no-close-on-backdrop no-close-on-esc centered>
          <div class="content-row">
            <span class="label-column">
            Click if you have finished uploading asset(s)
            </span>
            <span class="btn-column">
              <b-button @click="closeAndRedirect" class="btn button-primary" aria-label="ok"> ok </b-button>
            </span>
          </div>
          <div class="content-row">
            <span class="label-column">
            Click if you want to upload more asset(s)
            </span>
            <span class="btn-column">
              <b-button @click="resetAndShowUpload" class="btn button-primary" aria-label="continue uploading assets"> continue uploading assets </b-button>
            </span>
          </div>
        </b-modal>
      </div>
      <div class="modal_container modal_alart">
        <b-modal class="" ref="invalidCsvModal" :title="'Error Message!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div style="text-align: center;">
            <span>Please Select CSV file</span>
          </div>
          <div slot="modal-header" class="header-section">
            <div class="ic ic-hd"></div>
            <div class="head_txt">Error Message!</div>
            <button type="button" class="btn_close" @click="closeInvalidCsvAlert" aria-label="close">
              <span class="ic-close"></span>
            </button>
          </div>
          <div slot="modal-footer" class="w-100">
            <b-button @click="closeInvalidCsvAlert" class="btn button-primary float-right mr-2" aria-label="ok"> ok </b-button>
          </div>
        </b-modal>
      </div>
      <div>
        <b-modal style="padding: 0px;" ref="csvContentSuccessModal" hide-header no-close-on-backdrop no-close-on-esc centered>
          <div style="margin-top: 30px; text-align: center; color: rgb(80, 80, 80);">
            <div v-html="csvContentStatus"></div>
          </div>
          <div slot="modal-footer" class="w-100">
            <b-button @click="closeCsvContentStatusAlert" class="btn button-primary float-right mr-2" aria-label="ok"> ok </b-button>
          </div>
        </b-modal>
      </div>
      <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
            <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
          </div>
        </b-modal>
      </div>
      <div class="help-section">
        <div class="header">
          <span class="title">Help</span>
          <button class="close" type="button" @click="closeViewHelpSection" aria-label="close">X</button>
        </div>
        <div class="content-section">
          <p>Coming soon</p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  /* global AWS:true */
  import { mapState, mapActions } from 'vuex'
  import { AwsObject } from '../aws'
  import _ from 'lodash'
  import AddTagPopup from '../../tagging/components/AddTagPopup'

  var isCsvFile = function (file) {
    var fileName = file.fileName
    var regEx = /(.csv)$/i
    return regEx.test(fileName)
  }
  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
  }

  var convertArrayToCSV = function (array) {
    if (!array || (array && array.length === 0)) {
      return null
    }
    var csv = ''
    if (array.length > 0) {
      csv = csv + array[0]
    }
    for (var i = 1; i < array.length; i++) {
      csv = csv + ',' + array[i]
    }
    return csv
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

  export default {
    name: 'assetUpload',
    components: {
      AddTagPopup
    },
    data: () => {
      return {
        folders: [],
        owningLibrary: {},
        isBulkUpload: false,
        fileUploadArray: [],
        selected: [],
        selectAll: false,
        submitted: false,
        csvContentStatus: '',
        uploadSuccessTitle: '',
        enableUploadCSVContent: false,
        appliedTagMap: {},
        taggingEntityData: {},
        isShowTagPopup: false
      }
    },

    computed: {
      ...mapState({
        'currentEnvironment': state => state.learningContent.currentEnvironment
      })
    },

    created () {
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
    },

    updated () {
      this.showEllipsisTags()
      this.showTagsInTable()
      let self = this
      this.$nextTick(function () {
        window.addEventListener('resize', function () {
          self.showEllipsisTags()
          self.showTagsInTable()
        })
      })
    },

    mounted () {
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (learningSpace.category === 'Institute_Public') {
              this.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
            }
          }
        }
        if (this.folders.length > 0 && _.isEmpty(this.owningLibrary)) {
          this.owningLibrary = {uuid: this.folders[0].uuid, displayName: this.folders[0].displayName}
        }
      })
    },

    methods: {
      ...mapActions([
        'loadCurrentEnvironment',
        'loadLibrariesForUser',
        'uploadContent',
        'uploadCSVContent',
        'uploadCSVFile',
        'updateFileUriAndVersionIdAfterS3Upload'
      ]),

      viewHelpSection (event) {
        var el = $(event.currentTarget)
        var elPosleft = el.offset().left
        var elPosTop = el.offset().top
        var helpSection = $('.help-section')
        var mouseXPosition = event.clientX
        var windowWidth = window.innerWidth
        var mouseRightPosition = (windowWidth / 2) + 150
        $(helpSection).css({
          'left': elPosleft,
          'top': elPosTop + 40 + 'px'
        })
        $(helpSection).toggleClass('open')
        if (mouseXPosition > mouseRightPosition) {
          $(helpSection).css({
            'left': elPosleft - 370 + 'px',
            'top': elPosTop + 40 + 'px'
          })
        }
      },

      closeViewHelpSection () {
        $('.help-section').removeClass('open')
      },

      showEllipsisTags () {
        var tagListLength = $('.tag-list-length').height()
        if (tagListLength > 34) {
          $('.ellipsisTags').show()
        } else {
          $('.ellipsisTags').hide()
        }
      },

      showTagsInTable () {
        var tagListLength = $('.grid-tag-list-length').height()
        if (tagListLength > 34) {
          $('.ellipsisTagsInTable').show()
        } else {
          $('.ellipsisTagsInTable').hide()
        }
      },

      showTableTags () {
        this.$root.$emit('bv::show::modal', 'tableAssetTagsPopup')
      },

      closeTableTags () {
        this.$root.$emit('bv::hide::modal', 'tableAssetTagsPopup')
      },

      showAddTagPopup (event) {
        this.isShowTagPopup = true
        this.taggingEntityData = {title: this.title, type: 'assets', appliedTagMap: this.appliedTagMap}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },

      select () {
        this.selected = []
        if (!this.selectAll) {
          for (var i in this.fileUploadArray) {
            this.selected.push(this.fileUploadArray[i].id)
          }
        }
      },

      cancelDelete () {
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      },

      deleteSelected () {
        this.$refs.deleteConfirmModal.hide()
        this.fileUploadArray = this.fileUploadArray.filter((item) => {
          return (this.selected.indexOf(item.id) === -1)
        })
        this.selected = []
        this.selectAll = false
        if (this.fileUploadArray.length === 0) {
          this.reset()
        }
      },

      showDeleteConfirm () {
        if (this.selected.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },

      cancel () {
        this.$router.go(-1)
      },

      reset () {
        const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
        const csvInput = this.$refs.csvFileInput
        csvInput.type = 'text'
        csvInput.type = 'file'
        this.submitted = false
        this.fileUploadArray = []
        this.enableUploadCSVContent = false
      },

      chooseFile (isBulkUpload) {
        this.isBulkUpload = isBulkUpload
        var el = (isBulkUpload) ? 'csvFileId' : 'fileListId'
        var sel = 'id=' + el
        if (el === 'fileListId') {
          sel = 'rel=multipleFile'
        }
        $('input[type=file][' + sel + ']').click()
      },

      fileToBeUploaded (ev) {
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.prepareFileUploadArray(files)
      },

      prepareFileUploadArray (files) {
        if (files) {
          var timestamp = new Date().getTime()
          for (var i = 0; i < files.length; i++) {
            timestamp = timestamp + i
            this.addFileToUploadArray(files[i], timestamp)
          }
          if (this.fileUploadArray.length > 0) {
            if (this.isBulkUpload) {
              this.uploadLearningContent()
            }
          }
        }
      },

      addFileToUploadArray (newFile, timestamp) {
        var isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })

        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
      },

      uploadLearningContent () {
        if (this.enableUploadCSVContent) {
          this.$refs.loadingModal.show()
          this.uploadContentFromCsv()
        } else {
          if (this.fileUploadArray.length > 0) {
            if (this.isBulkUpload) {
              var file = this.fileUploadArray[0]
              if (file && !isCsvFile(file)) {
                this.fileUploadArray = []
                this.$refs.invalidCsvModal.show()
                return
              }
            }
            this.createFileUploadData()
          }
        }
      },

      uploadContentFromCsv () {
        this.submitted = true
        var contentList = []
        for (var i = 0; i < this.fileUploadArray.length; i++) {
          var content = this.fileUploadArray[i]
          let keys = Object.keys(this.appliedTagMap)
          if (keys.length > 0) {
            if (!content.appliedTagMap) {
              content.appliedTagMap = {}
            }
            keys.forEach(key => {
              content.appliedTagMap[key] = (!content.appliedTagMap[key]) ? this.appliedTagMap[key] : content.appliedTagMap[key].concat(this.appliedTagMap[key])
            })
          }
          var item = {
            'title': content.title,
            'uri': content.uri,
            'description': content.description,
            'type': content.type,
            'ancestor': content.ancestor,
            'appliedTagMap': content.appliedTagMap,
            'timestamp': content.timestamp,
            'topicLevelUuid': content.topicLevelUuid,
            'thumbnail': content.thumbnail,
            'contentFileType': content.contentFileType,
            'license': content.license,
            'usedInTopics': content.usedInTopics,
            'learningObjectives': content.learningObjectives
          }
          contentList.push(item)
        }
        if (contentList.length > 0) {
          this.uploadCSVContent({learningSpaceId: this.owningLibrary.uuid, contents: contentList, success: this.successCSVUpload, failure: this.errorCSVUpload})
        }
      },

      successCSVUpload (response) {
        var createdContents = response.createdContents
        var skippedContents = response.skippedContents
        this.removeProcessedContents(createdContents, skippedContents)
        if (this.fileUploadArray.length === 0) {
          this.showSuccessPopup(createdContents.length)
        }
      },

      errorCSVUpload (response) {
        console.log('Error occured while creating CSV content(s) ' + response)
      },

      createFileUploadData () {
        this.$refs.loadingModal.show()
        var fileId = (this.isBulkUpload) ? 'csvFileId' : 'fileListId'
        var url = (this.isBulkUpload) ? '/learningcontent/getContentFromCsv' : '/file/multipleFiles'
        if (window.FormData === undefined) {
          this.uploadFile(url, fileId, 'multipleFileUploadForm', this.fileUpLoadingMessage)
        } else {
          var data = new FormData()
          data.append('learningSpaceId', this.owningLibrary.uuid)
          if (this.isBulkUpload) {
            data.append($('#' + fileId).attr('name'), this.fileUploadArray[0].file, this.fileUploadArray[0].fileName)
            this.uploadCSVFile({data: data, success: this.fileUpLoadingMessage})
          } else {
            var timestamps = []
            for (var i = 0; i < this.fileUploadArray.length; i++) {
              var file = this.fileUploadArray[i]
              timestamps.push(file.timestamp)
            }
            if (timestamps.length > 0) {
              data.append('timestampCSV', convertArrayToCSV(timestamps))
            }
            this.createAndUploadContent()
          }
        }
      },

      fileUpLoadingMessage (data) {
        if (this.isBulkUpload) {
          this.csvMultipleUploadSucess(data)
          return
        }
        var createdContents = this.directUploadSuccess(data)
        if (this.fileUploadArray.length === 0) {
          this.showSuccessPopUp(createdContents.length)
        }
      },

      csvMultipleUploadSucess (data) {
        this.$refs.loadingModal.hide()
        this.csvContentStatus = data.STATUS
        this.$refs.csvContentSuccessModal.show()
        var contents = data.CONTENTS
        if (contents && contents.length > 0) {
          var updatedContents = this.updateContent(contents)
          this.fileUploadArray = updatedContents
          this.enableUploadCSVContent = true
        } else {
          this.reset()
        }
      },

      directUploadSuccess (data) {
        var createdContents = data.createdContents
        var skippedContents = data.skippedContents
        this.removeProcessedContents(createdContents, skippedContents)
        return createdContents
      },

      updateContent (contents) {
        var contentArray = []
        var timestamp = new Date().getTime()
        for (var i = 0; i < contents.length; i++) {
          var content = contents[i]
          content.id = timestamp + i
          content.timestamp = timestamp + i
          content.fileName = content.title
          content.contentFileType = content.contentFileType
          contentArray.push(content)
          // self.learningContentViewModel.timestampNameMap[content.timestamp] = content.title
        }
        return contentArray
      },

      createAndUploadContent () {
        this.submitted = true
        var fileUploadArrayClone = clone(this.fileUploadArray)
        this.createContentForUploadedFile(fileUploadArrayClone)
      },

      createContentForUploadedFile (fileUploadArrayClone) {
        var contentListToCreate = []
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          var content = fileUploadArrayClone[i]
          var item = {
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'thumbnail': content.thumbnail,
            'appliedTagMap': this.appliedTagMap
          }
          contentListToCreate.push(item)
        }
        if (contentListToCreate.length > 0) {
          this.uploadContent({learningSpaceId: this.owningLibrary.uuid, contents: contentListToCreate, success: this.uploadFileAfterCreateContentSuccessCallback, failure: this.uploadFileAfterCreateContentErrorCallback})
        }
      },

      uploadFileAfterCreateContentSuccessCallback (response) {
        var createdContents = response.createdContents
        var skippedContents = response.skippedContents
        if (createdContents.length > 0) {
          // uploading files on S3 for created contents
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
        }
        this.removeProcessedContents(createdContents, skippedContents)
        if (this.fileUploadArray.length === 0) {
          this.showSuccessPopup(createdContents.length)
        }
      },

      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ' + response)
      },

      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded)
        }
      },

      storeFilesToS3 (filesToBeUploaded) {
        var s3AwsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        this.$parent.setupUploadProgressFileList(filesToBeUploaded)
        let uploadProgressStatus = {}
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          if(item.fileData.fileName && item.fileData.fileName.indexOf('zip')!=-1){
            params["ContentDisposition"] = 'attachment; filename="' + item.fileData.fileName + '"'
          }
          var options = {partSize: 10 * 1024 * 1024, queueSize: 1}
          s3AwsRef.upload(params, options).on('httpUploadProgress', (ev) => {
            let uuid = ev.key.substring(0, ev.key.indexOf('-'))
            let uploaded = Math.round(ev.loaded / ev.total * 100)
            let progressHtml = '<span><strong>' + item.fileData.fileName + '</strong>: ' + uploaded + '%</span>'
            this.$parent.showFileUploadProgress = true
            $('#' + uuid).html(progressHtml)
            uploadProgressStatus[uuid] = uploaded
          }).send((err, data) => {
            if (Object.keys(uploadProgressStatus).length === filesToBeUploaded.length) {
              let isCompleted = false
              Object.values(uploadProgressStatus).forEach(value => {
                isCompleted = (value === 100)
              })
              if (isCompleted) {
                this.$parent.showFileUploadProgress = false
                this.$parent.uploadProgressFileList = []
              }
            }
            if (err) {
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: '<strong>"' + item.fileData.fileName + '" Failed To Upload</strong>'
                })
              }, 500)
              return
            }
            var uri = item.uri
            if (uri.indexOf('?versionId=') === -1) {
              uri = uri.concat('?versionId=' + data.VersionId)
              this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
            }
          })
        })
      },

      removeProcessedContents (createdContents, skippedContents) {
        var allContents = []
        if (createdContents.length > 0) {
          $.each(createdContents, (i, created) => {
            allContents.push(created)
          })
        }
        if (skippedContents.length > 0) {
          $.each(createdContents, (i, skipped) => {
            allContents.push(skipped)
          })
        }
        if (allContents.length > 0) {
          $.each(allContents, (i, content) => {
            $.each(this.fileUploadArray, (j, item) => {
              if (content.timestamp.toString() === item.timestamp.toString()) {
                this.fileUploadArray.splice(j, 1)
                return false
              }
            })
          })
        }
      },

      showSuccessPopup (length) {
        this.assetTags = []
        this.$refs.loadingModal.hide()
        this.uploadSuccessTitle = length + ((length > 1) ? ' internal assets uploaded' : ' internal asset uploaded')
        this.$refs.uploadSuccessModal.show()
      },

      closeAndRedirect () {
        this.$refs.uploadSuccessModal.hide()
        return this.$router.push({ name: 'results' })
      },

      resetAndShowUpload () {
        this.$refs.uploadSuccessModal.hide()
        this.submitted = false
        this.reset()
      },

      closeInvalidCsvAlert () {
        this.$refs.invalidCsvModal.hide()
        this.reset()
      },

      closeCsvContentStatusAlert () {
        this.$refs.csvContentSuccessModal.hide()
      },

      uploadFile (url, fileElementId, formId, success, error) {
        $.ajaxSetup({
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        })
        var data = $('#' + formId).serializeObject()
        $.ajaxFileUpload({
          url: url,
          secureuri: false,
          fileElementId: fileElementId,
          data: data,
          dataType: 'text',
          success: success,
          error: error
        })
      }
    }
  }
</script>

<style scoped>
    .hidden-container{
        visibility: hidden;
        height: 1px;
    }

    .card {
        height: 345px;
		border: 0;
		background: #f5f5f5;
		box-shadow: 2px 1px 6px 0px #b9b9b9;
		border-radius: 0;
		margin: 0 33px;
		position:relative;
    }

    .card-body {
        margin-top: 0px;
    }

    thead {
        background: #addde4;
    }

	.ellipsisTags, .ellipsisTagsInTable {
		float:right;
		cursor:pointer;
	}

	.tag-list-length {
		max-width: calc(100% - 45px);
		float: left;
	}

	.grid-tag-list-length {
		max-width: calc(100% - 45px);
		float: left;
	}

	.first-column {
		width:2%;
	}

	.second-column, .third-column, .fourth-column, .last-column {
		width:24.99%;
		border-right: 0;
		border-bottom: 0;
		float:left;

	}

	.second-column {
		border-left:0;
	}

	.label-section {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		float:left;
	}

	.help-label {
		margin: 0px 0 0 0;
		opacity: 0.5;
		line-height: 30px;
        margin-top: -4px;
        float: left;
	}

    #tagGeneral {
      border-bottom: 1px solid #e6e6e6 !important;
    }

    .open {
		display:block;
	}

</style>



// WEBPACK FOOTER //
// src/app/learningContent/components/AssetUpload.vue